export enum EFiltersActions {
  SET_FILTER = 'filters/SET_FILTER',
  RESET_FILTER = 'filters/RESET_FILTER',
  REFRESH_FILTER = 'filters/REFRESH_FILTER'
}
